import { combineReducers } from 'redux';

import translationDataReducer from '../commonReducers/translationDataReducer';
import configsDataReducer from '../commonReducers/configsDataReducer';
import queryParamsReducer from '../commonReducers/queryParamsReducer';
import fontReducer from '../commonReducers/fontReducer';
import appliancesReducer from '../commonReducers/appliancesReducer';

import marketplaceDataReducer from '../dashboardReducers/marketplaceReducer';
import recoDetailsReducer from '../dashboardReducers/recoDetailsReducer';

const allReducers = combineReducers({
  translationsData: translationDataReducer,
  configs: configsDataReducer,
  queryParams: queryParamsReducer,
  fontData: fontReducer,
  appliances: appliancesReducer,
  marketplaceData: marketplaceDataReducer,
  recoDetailsData : recoDetailsReducer
})

export default function getPublicWidgetReducers() {
  return allReducers;
}
